import "@fortawesome/fontawesome-free/css/all.min.css";

import "@/css/bootstrap.css";
import "@/css/style.css";
import "@/css/NavTabs.css";
import "@/css/main.css";
import { LeftMenu } from "./LeftMenu";
import { useState, useEffect } from "react";
import { Outlet } from "react-router";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { ErrorPage } from "@/pages/Error/Error";
import { ModalLogin } from "@/components/modals/LoginModal";
import { useAuth } from "@/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import type { Usuario } from "@/ts/typings/clases";
import { sendAjaxRequest } from "@/ts/api/comunicacion";


export function TemplateMenu() {
	const { auth } = useAuth();
	const [time, setTime] = useState(new Date());
	const [menuOpenState, setMenuOpenState] = useState<"gn-open-all" | "gn-open-part" | "gn-open-fixed" | "">("");

	const onNavigate = () => { setMenuOpenState(""); };

	const { data: userInfo } = useUserInfo();

	useEffect(() => {
		const timer = setInterval(() => {
			setTime(new Date());
		}, 60000); // Actualiza cada minuto
		return () => { clearInterval(timer); };
	}, []);

	return (
		<>
			<div className="main-wrapper">
				<div className="gn-menu-main" >
					<div className="gn-trigger">
						<a className="menu-toggle" onMouseEnter={() => { setMenuOpenState("gn-open-part"); }} onMouseLeave={() => { setMenuOpenState(""); }} onClick={() => { setMenuOpenState("gn-open-all"); }}>
							<img src="/img/icons/newIconoWunder.svg" alt="Men" className="icon-menu" style={{ width: 24, height: 24 }} />
						</a>
					</div>
					<div className="title-panel">
						PIHER ALMACEN
					</div>
					<div className="divider" />
					<div className="top-clock">
						{time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
					</div>
					<div className="divider" />
					<div className="user-logged">
						{getRolTexto(userInfo?.rol)}
					</div>
				</div>
				<nav className={`gn-menu-wrapper ${menuOpenState}`} onMouseEnter={() => { setMenuOpenState("gn-open-all"); }}>
					<LeftMenu onNavigate={onNavigate} />
				</nav>
			</div>

			<div onClick={() => { setMenuOpenState(""); }} style={{ display: "flex", height: "100%" }} >
				<ErrorBoundary fallback={<ErrorPage />}>
					<Outlet />
				</ErrorBoundary >
			</div>
			<ModalLogin show={auth == null} />
		</>
	);
}

function useUserInfo() {
	return useQuery<Usuario>({
		queryKey: ["myself"],
		queryFn: async () => {
			const url = "/api/v1/myself";
			const result = await sendAjaxRequest<Usuario>("GET", url, {});
			return result;
		},
	});
}

function getRolTexto(rol: Usuario["rol"] | undefined) {
	if (!rol) return "";

	switch (rol) {
		case "admin":
		case "administracion":
			return "Administrador";
		case "jefeFabrica":
			return "Jefe de Fabrica";
		case "carretillero":
			return "carretillero";
		case "montador":
			return "montador";
		case "operario":
			return "operario";
		default:
			return rol;
	}
}